/* ============================================================================
   AJÁNLATKÉRÉS – TERMÉKKÉPEK AZ ÉRTESÍTŐ LEVÉLBEN (quote-mail-images.js)
   ---------------------------------------------------------------------------
   Betöltés: layout/theme.liquid, KÖZVETLENÜL a quote-cart.js UTÁN, defer-rel:

     <script src="{{ 'quote-cart.js'        | asset_url }}" defer></script>
     <script src="{{ 'quote-mail-images.js' | asset_url }}" defer></script>

   Mit csinál:
   Az ajánlatkosár beküldésekor minden tételsor végére beírja a termékkép
   közvetlen linkjét a contact[Tetelek] mezőbe, így az info@ postafiókba
   érkező "Új vásárlói üzenet" levélben minden tétel mellett ott a képre
   mutató, kattintható link.

   Miért csak link, miért nem beágyazott kép:
   - A Shopify kapcsolati űrlap (form 'contact') értesítő levelének sablonja
     NEM szerkeszthető (Beállítások > Értesítések alatt nincs ilyen sablon),
     és a mezőértékeket escape-elt szövegként, <pre> blokkban jeleníti meg,
     ezért <img> nem tehető bele.
   - Csatolmány sem járható út: a Shopify kapcsolati űrlapja NEM támogatja a
     fájlfeltöltést. (Ellenőrizve 2026-08-15-én: multipart/form-data-val
     elküldött PDF esetén a Shopify visszadobja a beküldést, levél nem megy
     ki; enctype nélkül pedig a fájlból csak a fájlnév megy el szövegként.)

   Biztonsági elv: ez a fájl SOHA nem akadályozhatja meg az ajánlatkérést.
   Nem hívunk preventDefault-ot, nem küldjük be mi az űrlapot (a boltban aktív
   a Shopify bot-védelem, ami maga intézi a beküldést), és minden művelet
   try/catch-ben fut. Hiba esetén az ajánlatkérés a megszokott módon elmegy,
   csak a képlinkek maradnak le.
   ========================================================================= */
(function () {
  'use strict';

  var STORE_KEY = 'mc_quote_cart';   /* ugyanaz, mint a quote-cart.js-ben */
  var LABEL     = ' | kép: ';

  function readItems() {
    var raw = null;
    try { raw = localStorage.getItem(STORE_KEY); } catch (e) { return []; }
    if (!raw) return [];
    try {
      var arr = JSON.parse(raw);
      return (arr && arr.length) ? arr : [];
    } catch (e) { return []; }
  }

  function isBasketForm(form) {
    if (!form || form.nodeName !== 'FORM') return false;
    if (form.hasAttribute && form.hasAttribute('data-quote-basket-form')) return true;
    return !!(form.classList && form.classList.contains('quote-basket__form'));
  }

  /* Teljes méretű, abszolút képlink. A kosárban tárolt URL egy 120 px-es
     bélyegképre mutat (&width=120) – ezt levágjuk, hogy a levélben a nagy
     kép nyíljon meg. */
  function fullImageUrl(url) {
    if (!url) return '';
    var u = String(url);
    if (u.indexOf('//') === 0) u = window.location.protocol + u;
    else if (!/^https?:\/\//i.test(u)) {
      var origin = window.location.origin ||
                   (window.location.protocol + '//' + window.location.host);
      u = origin + (u.charAt(0) === '/' ? '' : '/') + u;
    }
    u = u.replace(/([?&])width=\d+&?/gi, '$1').replace(/[?&]$/, '');
    return u;
  }

  document.addEventListener('submit', function (e) {
    try {
      var form = e.target;
      if (!isBasketForm(form)) return;

      var field = form.querySelector('[name="contact[Tetelek]"]');
      if (!field || !field.value) return;          /* a quote-cart.js tölti ki */

      var items = readItems();
      var lines = String(field.value).split('\n');
      if (lines.length !== items.length) return;   /* eltérés: inkább nem nyúlunk hozzá */

      for (var i = 0; i < lines.length; i++) {
        var img = fullImageUrl(items[i] && items[i].image);
        if (img && lines[i].indexOf(img) === -1) lines[i] += LABEL + img;
      }
      field.value = lines.join('\n');
    } catch (err) { /* soha nem akasztjuk meg a beküldést */ }
  }, false);
})();
